import {
  CLONE_PRODUCT,
  CLONE_PRODUCT_FAILED,
  CLONE_PRODUCT_SUCCESS,
  CREATE_PRODUCT,
  CREATE_PRODUCT_CATEGORY,
  CREATE_PRODUCT_CATEGORY_FAILED,
  CREATE_PRODUCT_CATEGORY_SUCCESS,
  CREATE_PRODUCT_FAILED,
  CREATE_PRODUCT_SUCCESS,
  DELETE_PRODUCT,
  DELETE_PRODUCT_FAILED,
  DELETE_PRODUCT_SUCCESS,
  GET_CATEGORY_FOR_FORM,
  GET_CATEGORY_FOR_FORM_FAILED,
  GET_CATEGORY_FOR_FORM_SUCCESS,
  GET_FEATURE_RECIPIENTS,
  GET_FEATURE_RECIPIENTS_FAILED,
  GET_FEATURE_RECIPIENTS_SUCCESS,
  GET_ORDER,
  GET_ORDER_DETAILS,
  GET_ORDER_DETAILS_FAILED,
  GET_ORDER_DETAILS_SUCCESS,
  GET_ORDER_FAILED,
  GET_ORDER_SUCCESS,
  GET_PRODUCT,
  GET_PRODUCTS,
  GET_PRODUCTS_FAILED,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCT_CATEGORY,
  GET_PRODUCT_CATEGORY_FAILED,
  GET_PRODUCT_CATEGORY_SUCCESS,
  GET_PRODUCT_FAILED,
  GET_PRODUCT_ORDERS,
  GET_PRODUCT_ORDERS_FAILED,
  GET_PRODUCT_ORDERS_SUCCESS,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_USER_TAGS,
  GET_PRODUCT_USER_TAGS_FAILED,
  GET_PRODUCT_USER_TAGS_SUCCESS,
  GET_STRIPE_PRICES,
  GET_STRIPE_PRICES_FAILED,
  GET_STRIPE_PRICES_SUCCESS,
  GET_STRIPE_PRODUCTS,
  GET_STRIPE_PRODUCTS_FAILED,
  GET_STRIPE_PRODUCTS_SUCCESS,
  GET_TEASER_PRODUCTS,
  GET_TEASER_PRODUCTS_FAILED,
  GET_TEASER_PRODUCTS_SUCCESS,
  HIDE_CLONE_PRODUCT_MODAL,
  HIDE_DELETE_PRODUCT_MODAL,
  OPEN_CLONE_PRODUCT_MODAL,
  OPEN_DELETE_PRODUCT_MODAL,
  RESET_CATEGORY_FOR_FORM,
  RESET_FEATURE_RECIPIENTS,
  RESET_ORDER,
  RESET_ORDER_DETAILS,
  RESET_PRODUCT,
  RESET_PRODUCT_CATEGORY,
  RESET_PRODUCT_USER_TAGS,
  RESET_STRIPE_PRICES,
  RESET_TEASER_PRODUCTS,
  SET_ORDER_CHECKOUT_SESSION,
  SUBMIT_ORDER_FORM,
  SUBMIT_ORDER_FORM_FAILED,
  SUBMIT_ORDER_FORM_SUCCESS,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_CATEGORY,
  UPDATE_PRODUCT_CATEGORY_FAILED,
  UPDATE_PRODUCT_CATEGORY_SUCCESS,
  UPDATE_PRODUCT_FAILED,
  UPDATE_PRODUCT_SUCCESS,
} from "./actionTypes"

export const getProductOrders = params => ({
  type: GET_PRODUCT_ORDERS,
  payload: params,
})

export const getProductOrdersSuccess = response => ({
  type: GET_PRODUCT_ORDERS_SUCCESS,
  payload: response,
})

export const getProductOrdersFailed = error => ({
  type: GET_PRODUCT_ORDERS_FAILED,
  payload: error,
})

export const getProducts = params => ({
  type: GET_PRODUCTS,
  payload: params,
})

export const getProductsSuccess = response => ({
  type: GET_PRODUCTS_SUCCESS,
  payload: response,
})

export const getProductsFailed = error => ({
  type: GET_PRODUCTS_FAILED,
  payload: error,
})

export const getStripeProducts = params => ({
  type: GET_STRIPE_PRODUCTS,
  payload: params,
})

export const getStripeProductsSuccess = response => ({
  type: GET_STRIPE_PRODUCTS_SUCCESS,
  payload: response,
})

export const getStripeProductsFailed = error => ({
  type: GET_STRIPE_PRODUCTS_FAILED,
  payload: error,
})

export const getStripePrices = params => ({
  type: GET_STRIPE_PRICES,
  payload: params,
})

export const getStripePricesSuccess = response => ({
  type: GET_STRIPE_PRICES_SUCCESS,
  payload: response,
})

export const getStripePricesFailed = error => ({
  type: GET_STRIPE_PRICES_FAILED,
  payload: error,
})

export const resetStripePrices = () => ({
  type: RESET_STRIPE_PRICES,
  payload: {},
})

export const createProduct = params => ({
  type: CREATE_PRODUCT,
  payload: params,
})

export const createProductSuccess = response => ({
  type: CREATE_PRODUCT_SUCCESS,
  payload: response,
})

export const createProductFailed = error => ({
  type: CREATE_PRODUCT_FAILED,
  payload: error,
})

export const openDeleteProductModal = () => ({
  type: OPEN_DELETE_PRODUCT_MODAL,
  payload: {},
})

export const hideDeleteProductModal = () => ({
  type: HIDE_DELETE_PRODUCT_MODAL,
  payload: {},
})

export const deleteProduct = params => ({
  type: DELETE_PRODUCT,
  payload: params,
})

export const deleteProductSuccess = response => ({
  type: DELETE_PRODUCT_SUCCESS,
  payload: response,
})

export const deleteProductFailed = error => ({
  type: DELETE_PRODUCT_FAILED,
  payload: error,
})

export const getProduct = params => ({
  type: GET_PRODUCT,
  payload: params,
})

export const getProductSuccess = response => ({
  type: GET_PRODUCT_SUCCESS,
  payload: response,
})

export const getProductFailed = error => ({
  type: GET_PRODUCT_FAILED,
  payload: error,
})

export const resetProduct = () => ({
  type: RESET_PRODUCT,
  payload: {},
})

export const getFeatureRecipients = params => ({
  type: GET_FEATURE_RECIPIENTS,
  payload: params,
})

export const getFeatureRecipientsSuccess = response => ({
  type: GET_FEATURE_RECIPIENTS_SUCCESS,
  payload: response,
})

export const getFeatureRecipientsFailed = error => ({
  type: GET_FEATURE_RECIPIENTS_FAILED,
  payload: error,
})

export const resetFeatureRecipients = () => ({
  type: RESET_FEATURE_RECIPIENTS,
  payload: {},
})

export const updateProduct = params => ({
  type: UPDATE_PRODUCT,
  payload: params,
})

export const updateProductSuccess = response => ({
  type: UPDATE_PRODUCT_SUCCESS,
  payload: response,
})

export const updateProductFailed = error => ({
  type: UPDATE_PRODUCT_FAILED,
  payload: error,
})

export const createProductCategory = params => ({
  type: CREATE_PRODUCT_CATEGORY,
  payload: params,
})

export const createProductCategorySuccess = response => ({
  type: CREATE_PRODUCT_CATEGORY_SUCCESS,
  payload: response,
})

export const createProductCategoryFailed = error => ({
  type: CREATE_PRODUCT_CATEGORY_FAILED,
  payload: error,
})

export const resetProductCategory = () => ({
  type: RESET_PRODUCT_CATEGORY,
  payload: {},
})

export const updateProductCategory = params => ({
  type: UPDATE_PRODUCT_CATEGORY,
  payload: params,
})

export const updateProductCategorySuccess = response => ({
  type: UPDATE_PRODUCT_CATEGORY_SUCCESS,
  payload: response,
})

export const updateProductCategoryFailed = error => ({
  type: UPDATE_PRODUCT_CATEGORY_FAILED,
  payload: error,
})

export const getProductCategory = params => ({
  type: GET_PRODUCT_CATEGORY,
  payload: params,
})

export const getProductCategorySuccess = response => ({
  type: GET_PRODUCT_CATEGORY_SUCCESS,
  payload: response,
})

export const getProductCategoryFailed = error => ({
  type: GET_PRODUCT_CATEGORY_FAILED,
  payload: error,
})

export const getOrderDetails = params => ({
  type: GET_ORDER_DETAILS,
  payload: params,
})

export const getOrderDetailsSuccess = response => ({
  type: GET_ORDER_DETAILS_SUCCESS,
  payload: response,
})

export const getOrderDetailsFailed = error => ({
  type: GET_ORDER_DETAILS_FAILED,
  payload: error,
})

export const resetOrderDetails = () => ({
  type: RESET_ORDER_DETAILS,
  payload: {},
})

export const getCategoryForForm = params => ({
  type: GET_CATEGORY_FOR_FORM,
  payload: params,
})

export const getCategoryForFormSuccess = response => ({
  type: GET_CATEGORY_FOR_FORM_SUCCESS,
  payload: response,
})

export const getCategoryForFormFailed = error => ({
  type: GET_CATEGORY_FOR_FORM_FAILED,
  payload: error,
})

export const resetCategoryForForm = () => ({
  type: RESET_CATEGORY_FOR_FORM,
  payload: {},
})

export const getTeaserProducts = params => ({
  type: GET_TEASER_PRODUCTS,
  payload: params,
})

export const getTeaserProductsSuccess = response => ({
  type: GET_TEASER_PRODUCTS_SUCCESS,
  payload: response,
})

export const getTeaserProductsFailed = error => ({
  type: GET_TEASER_PRODUCTS_FAILED,
  payload: error,
})

export const resetTeaserProducts = () => ({
  type: RESET_TEASER_PRODUCTS,
  payload: {},
})

export const submitOrderForm = params => ({
  type: SUBMIT_ORDER_FORM,
  payload: params,
})

export const submitOrderFormSuccess = response => ({
  type: SUBMIT_ORDER_FORM_SUCCESS,
  payload: response,
})

export const submitOrderFormFailed = error => ({
  type: SUBMIT_ORDER_FORM_FAILED,
  payload: error,
})

export const getOrder = params => ({
  type: GET_ORDER,
  payload: params,
})

export const getOrderSuccess = response => ({
  type: GET_ORDER_SUCCESS,
  payload: response,
})

export const getOrderFailed = error => ({
  type: GET_ORDER_FAILED,
  payload: error,
})

export const resetOrder = () => ({
  type: RESET_ORDER,
  payload: {},
})

export const getProductUserTags = params => ({
  type: GET_PRODUCT_USER_TAGS,
  payload: params,
})

export const getProductUserTagsSuccess = response => ({
  type: GET_PRODUCT_USER_TAGS_SUCCESS,
  payload: response,
})

export const getProductUserTagsFailed = error => ({
  type: GET_PRODUCT_USER_TAGS_FAILED,
  payload: error,
})

export const resetProductUserTags = () => ({
  type: RESET_PRODUCT_USER_TAGS,
  payload: {},
})
export const setOrderCheckoutSession = params => ({
  type: SET_ORDER_CHECKOUT_SESSION,
  payload: params,
})

export const openCloneProductModal = () => ({
  type: OPEN_CLONE_PRODUCT_MODAL,
  payload: {},
})

export const hideCloneProductModal = () => ({
  type: HIDE_CLONE_PRODUCT_MODAL,
  payload: {},
})

export const cloneProduct = params => ({
  type: CLONE_PRODUCT,
  payload: params,
})

export const cloneProductSuccess = response => ({
  type: CLONE_PRODUCT_SUCCESS,
  payload: response,
})

export const cloneProductFailed = error => ({
  type: CLONE_PRODUCT_FAILED,
  payload: error,
})
